export const Color = {
    primary: '#ffffff',
    background: '#E5E5E5',
    coreTheme: '#0094FF',
    accent: '#E1F1FF',
    textColor: '#000000',
    warning: '#ff4c4c',
    warningLight: '#FFD8D8',
    selection: '#B7E1FF',
    yellow: '#FFEEC3',
    lightYellow: '#FFF7E1',
    community: '#9B51E0',
    knowledge: '#0094FF',
    nature: '#219653',
    fitness: '#F2994A',
}
